/** @module share */

/**
 * Generates a list of social network objects.
 *
 * @param {string} url - The url of the page.
 * @param {string} title - The title of the page.
 * @param {string} description - The description fo the page.
 * @return {object[]} The social networks list.
 */
export function networks(url, title, description) {
    url = encodeURIComponent(url);
    title = encodeURIComponent(title);
    description = encodeURIComponent(description);

    return [
        {
            name: 'Email',
            icon: 'mail',
            href: `mailto:?subject=${title}&body=${description}${encodeURIComponent('\n\r')}${url}`,
            active: true,
        },
        {
            name: 'Facebook',
            href: `https://www.facebook.com/sharer/sharer.php?display=page&u=${url}&quote=${title}${encodeURIComponent(
                '\n\r',
            )}${description}`,
            active: true,
        },
        // We dont have clients that need this feature yet but it is included as a possibility.
        // fbId muss be generated and included for messenger to work.

        // {
        //     name: 'Messenger',
        //     href:
        //         'http://www.facebook.com/dialog/send?' +
        //         'app_id=' +
        //         fbId +
        //         '&display=popup' +
        //         '&href=' +
        //         url +
        //         '&link=' +
        //         url +
        //         '&redirect_uri=' +
        //         url +
        //         '&quote=' +
        //         description,
        //     active: true,
        // },
        {
            name: 'Twitter',
            href: `https://twitter.com/share?text=${description}&url=${url}`,
            active: true,
        },
        {
            name: 'WhatsApp',
            href: 'https://api.whatsapp.com/send?text=' + description + encodeURIComponent('\n\r') + url,
            active: false,
        },
        {
            name: 'Pinterest',
            href: 'https://www.pinterest.com/pin/create/button/?url=' + url,
            active: false,
        },
        {
            name: 'LinkedIn',
            href: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${description}&source=LinkedIn`,
            active: false,
        },
        {
            name: 'Xing',
            href: `https://www.xing.com/spi/shares/new?url=${url}`,
            active: false,
        },
        {
            name: 'Reddit',
            href: 'https://www.reddit.com/submit/?url=' + url,
            active: false,
        },
        {
            name: 'Pinterest',
            href: `https://pinterest.com/pin/create/button/?url=${url}&description=${description}`,
            active: false,
        },
    ];
}
